import React from 'react';

interface LookupDateTemplateProps {
  date?: string | Date;
}

/**
 * Date display for lookup grid.
 */
export const LookupDateTemplate: React.FC<LookupDateTemplateProps> = ({ date }) => {
  if (!date) return <>-</>;
  return <>{new Date(date).toLocaleDateString()}</>;
};

/** Syncfusion grid template wrapper for service date */
export const serviceDateTemplate = (props: { serviceDate?: string | Date }) => (
  <LookupDateTemplate date={props.serviceDate} />
);

/** Syncfusion grid template wrapper for created date */
export const createdDateTemplate = (props: { createdDate?: string | Date }) => (
  <LookupDateTemplate date={props.createdDate} />
);

export default LookupDateTemplate;
